$ = require 'jquery'

class Login
  applyStyles: ->
    href = $('.signin').attr('href')
    $('.signin').attr('href', href + '?forlogin')
#    $('body').addClass('login')

module.exports = new Login